import { useSyncExternalStore } from 'react';

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

/**
 * Whether the visitor has asked for less motion, SUBSCRIBED rather than sampled once.
 *
 * Read through `useSyncExternalStore` and not through a library hook: the value has to be right on the
 * first client render, and a hook that starts at its server default and only corrects itself when the
 * query CHANGES never corrects itself at all for someone who had the setting on before the page loaded.
 * The server snapshot is `false` because the server cannot know, so anything gated on this starts in
 * its moving state and settles on hydration — which is the smaller surprise of the two.
 *
 * Only for the handful of places where the answer decides what is RENDERED (a still instead of a
 * player, a scroll loop that never starts). Anything that merely animates says so in CSS, with
 * `motion-reduce:` or a `prefers-reduced-motion` block in `-styles/theme.css`.
 */
export function usePrefersReducedMotion() {
	return useSyncExternalStore(
		(onChange) => {
			const query = window.matchMedia(REDUCED_MOTION);
			query.addEventListener('change', onChange);
			return () => query.removeEventListener('change', onChange);
		},
		() => window.matchMedia(REDUCED_MOTION).matches,
		() => false,
	);
}
